/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Select_Event_PlaceholderInputs */

const en_notes_select_event_placeholder = /** @type {(inputs: Notes_Select_Event_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select an Event`)
};

const fr_notes_select_event_placeholder = /** @type {(inputs: Notes_Select_Event_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un evenement`)
};

const de_notes_select_event_placeholder = /** @type {(inputs: Notes_Select_Event_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Veranstaltung aus.`)
};

const it_notes_select_event_placeholder = /** @type {(inputs: Notes_Select_Event_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un evento`)
};

const ru_notes_select_event_placeholder = /** @type {(inputs: Notes_Select_Event_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите мероприятие.`)
};

const es_notes_select_event_placeholder = /** @type {(inputs: Notes_Select_Event_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor seleccione un evento`)
};

const zh_cn2_notes_select_event_placeholder = /** @type {(inputs: Notes_Select_Event_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择一项活动`)
};

const ja_notes_select_event_placeholder = /** @type {(inputs: Notes_Select_Event_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを選択してください`)
};

const hi_notes_select_event_placeholder = /** @type {(inputs: Notes_Select_Event_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक कार्यक्रम चुनें`)
};

const pt_pt2_notes_select_event_placeholder = /** @type {(inputs: Notes_Select_Event_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione um evento.`)
};

/**
* | output |
* | --- |
* | "Please select an Event" |
*
* @param {Notes_Select_Event_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_select_event_placeholder = /** @type {((inputs?: Notes_Select_Event_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Select_Event_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_notes_select_event_placeholder(inputs)
	if (locale === "de") return de_notes_select_event_placeholder(inputs)
	if (locale === "it") return it_notes_select_event_placeholder(inputs)
	if (locale === "ru") return ru_notes_select_event_placeholder(inputs)
	if (locale === "es") return es_notes_select_event_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_notes_select_event_placeholder(inputs)
	if (locale === "ja") return ja_notes_select_event_placeholder(inputs)
	if (locale === "hi") return hi_notes_select_event_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_notes_select_event_placeholder(inputs)
	return en_notes_select_event_placeholder(inputs)
});